// extracted by mini-css-extract-plugin
module.exports = {"BreadCrumbs":"BreadCrumbs_BreadCrumbs__9u5ms","BreadCrumbFont":"BreadCrumbs_BreadCrumbFont__Osu6w","linkAsSpan":"BreadCrumbs_linkAsSpan__ZMeIR"};